import { DynamicFormFieldOption } from './dynamic-form-field-option.model';

export class DynamicFormFieldOptionList {
  [listUniqueKey: string]: DynamicFormFieldOption[];
}
